export enum RevocationReason {
    Fallecimiento = 0,
    ErrorAlta = 1,
    SolicitudPaciente = 2,
    BajaAdministrativa = 3,
    PerdidaWallet = 4,
    Otro = 5
}
